import { AppDispatch } from '../../data/store';
import { WebSocketSessionInfo } from './webSocketService';
import { setReservationEventEmitted } from '../../data/reservation.slice';
import {
  ReservationEventType,
  ReservationEventDetail,
  ReservationEventDetailSMS,
} from '../../data/events/reservation';
import { reservationSlice as reservationAdapterSlice } from '@/data/slices/reservation.slice';

/**
 * Method for handling all Reservation Events
 * @param sessionInfo The webSocketService sessionInfo object. Contains data copied over from the Redux store as needed
 * @param dispatch The Redux store dispatch function
 * @param detailType A string representing the type of event. Must be one of the ReservationEventType enum values
 * @param detail An object containing the event data, in this case a ReservationEventDetail
 */
function updateReservation(
  sessionInfo: WebSocketSessionInfo,
  dispatch: AppDispatch,
  detailType: ReservationEventType,
  detail: ReservationEventDetail | ReservationEventDetailSMS,
) {
  switch (detailType) {
    case ReservationEventType.ReservationActivated:
    case ReservationEventType.ReservationActivatedSMS:
    case ReservationEventType.ReservationDeactivated:
    case ReservationEventType.ReservationDrafted:
    case ReservationEventType.ReservationCanceled:
      // TODO: Remove the below line once the old reservation slice is removed
      dispatch(setReservationEventEmitted({ detailType, detail }));
      // New reservation slice action
      dispatch(
        reservationAdapterSlice.actions.setReservationEventEmitted({
          detailType,
          detail,
        }),
      );
      break;
  }
}

export { ReservationEventType, updateReservation };
